<template>
  <div class="container-box">
    <el-table :data="sortedPickUpInfo" border max-height="400px" size="mini">
      <el-table-column label="订单编号" align="center" width="250">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="ferryOrderDetails(scope.row)">
            {{ scope.row.orderNo }}
          </el-button>
          <el-tooltip class="item" effect="dark" content="复制" placement="right-start">
            <el-button
              icon="el-icon-document-copy"
              @click="copyOrderNo(scope.row.orderNo)"
              circle
              size="mini"
            />
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="出发地" align="center" prop="departureAddress" width="180">
        <template slot-scope="{ row }">
          <yd-link
            :value="row.departureAddress"
            type="location"
            :query="{
              longitude: row.startLongitude,
              latitude: row.startLatitude,
              name: row.departureAddress,
              lineName: info.lineName
            }"
          />
        </template>
      </el-table-column>
      <el-table-column label="目的地" align="center" prop="destinationAddress" width="180">
        <template slot-scope="{ row }">
          <yd-link
            :value="row.destinationAddress"
            type="location"
            :query="{
              longitude: row.endLongitude,
              latitude: row.endLatitude,
              name: row.destinationAddress,
              lineName: info.lineName
            }"
          />
        </template>
      </el-table-column>
      <el-table-column label="接送类型" align="center" prop="pickupType" width="100">
        <template slot-scope="scope">
          <span>
            {{ scope.row.pickupType }}（{{ scope.row.ferryPriceType === 2 ? '专' : '拼' }}）
          </span>
        </template>
      </el-table-column>
      <el-table-column label="接送方式" align="center" prop="pickupWay" />
      <el-table-column label="状态" align="center" prop="status" />
      <el-table-column label="支付金额（元）" align="center" prop="payAmount" />
      <el-table-column label="剩余金额（元）" align="center" prop="surplusAmount" />
      <el-table-column label="司机信息" align="center" prop="driverMsg">
        <template slot-scope="{ row }">
          <yd-link
            permi="driver_data_normal"
            :value="row.driverMsg && row.driverMsg !== '-' ? row.driverMsg : ''"
            :url="`/data-analysis/driver-data/normal/detail/${row.driverId}`"
            type="userInfo"
          />
        </template>
      </el-table-column>
      <el-table-column label="车辆信息" align="center" prop="carMsg">
        <template slot-scope="{ row }">
          <yd-link
            permi="vehicle_view"
            :value="row.carMsg && row.carMsg !== '-' ? row.carMsg : ''"
            type="vehicleDetail"
            :query="{ id: row.carId }"
          />
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import { copyText } from '@/util/util'

  export default {
    name: 'ferryOrderInfo',
    props: {
      info: {}
    },
    data() {
      return {}
    },
    computed: {
      // 按状态顺序和接送类型排序的接送信息列表
      sortedPickUpInfo() {
        if (!this.info.pickUpInfo || !Array.isArray(this.info.pickUpInfo)) {
          return []
        }

        // 状态顺序映射
        const statusOrder = {
          待支付: 1,
          待接单: 2,
          待出发: 3,
          接人中: 4,
          待乘客上车: 5,
          行程中: 6,
          送达完成: 7
        }

        return [...this.info.pickUpInfo].sort((a, b) => {
          // 先按状态排序
          const statusA = statusOrder[a.status] || 999
          const statusB = statusOrder[b.status] || 999

          if (statusA !== statusB) {
            return statusA - statusB
          }

          // 相同状态按接人-送人排序
          const typeOrder = { 接人: 1, 送人: 2 }
          const typeA = typeOrder[a.pickupType] || 999
          const typeB = typeOrder[b.pickupType] || 999

          return typeA - typeB
        })
      }
    },
    methods: {
      async copyOrderNo(orderNo) {
        await copyText(orderNo)
        this.$message({
          message: '复制成功',
          type: 'success'
        })
      },
      // 查看同城接送订单详情
      ferryOrderDetails(row) {
        this.$emit('ferryOrderDetails', row)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .container-box {
    margin: 12px 0 30px 0;
    padding: 0 10px;
  }
</style>
